import { BoxTitles } from "@boxes/BoxTitles";
import { Button, Drawer, Hairline, Input } from "@components";
import { useEffect, useState } from "react";

import styles from "@styles/forms-flow/filtered-audience.module.scss";

export const CustomerPhoneFilterForm = ({
  visible,
  onClose,
  node,
  onChange,
  onSave,
}) => {
  const [phone_1, setPhone_1] = useState((node.data.phone || [])[0] || null);
  const [phone_2, setPhone_2] = useState((node.data.phone || [])[1] || null);

  const getFreshNode = () => {
    const dataValue = {
      ...(node?.data || {}),
      phone: [phone_1, phone_2].filter((p) => !!p),
    };
    return {
      ...node,
      data: dataValue,
    };
  };

  useEffect(() => {
    onChange && onChange(getFreshNode());
  }, [phone_1, phone_2]);

  return (
    <Drawer
      visible={visible}
      onClose={() => onClose()}
      title={BoxTitles.CustomerPhoneFilter}
    >
      <Input
        prefix="Telefone 1"
        placeholder="Telefone 1"
        prefixWidth={75}
        autoFocus
        value={phone_1}
        className="mb-10"
        onChange={(text) => setPhone_1(text.target.value)}
      />

      <Input
        prefix="Telefone 2"
        placeholder="Telefone 2"
        prefixWidth={75}
        autoFocus
        value={phone_2}
        onChange={(text) => setPhone_2(text.target.value)}
      />

      <div className={styles.footer}>
        <Button
          design="primary"
          className="w-100"
          onClick={() => onSave(getFreshNode())}
        >
          Salvar
        </Button>
      </div>
    </Drawer>
  );
};
